import PropTypes from 'prop-types'
import React from 'react'
import { push } from 'react-router-redux'
import classes from './Orders.scss'

import moment, { urlFormat } from 'helpers/moment'
import mediaQueryMatches from 'helpers/mediaQuery'

import Button from 'components/Button'
import OrderForm from 'components/Orders/Form'
import OrdersList from 'components/Orders/List'

export class Orders extends React.Component {
  constructor (props) {
    super(props)

    this.state = { isMobile: false }
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    const matches = mediaQueryMatches('medium', 'max') // NOTE: Matches can be undefined, which means it had an error

    if (matches) {
      this.setState({ isMobile: true })
    } else {
      this.setState({ isMobile: false })
    }
  };

  renderCartButton = () => {
    return <Button stick stickOptions={{ hideUnstuck: true }}
      options={['red', 'block']}
      onlyOnce={false}
      callback={(e) => {
        let date = this.props.order.date || this.props.date

        e.stopPropagation()
        this.props.dispatch(push(
          `/orders${(date && `/${moment(date).format(urlFormat)}` || '')}/list`
        ))
      }}
    >
      View Cart{this.props.staging.length && ` (${this.props.staging.length})` || ''}
    </Button>
  };

  renderForm = (props = {}) => {
    return <OrderForm {...this.props} {...props} />
  };

  renderList = (props = {}) => {
    return <OrdersList {...this.props} {...props} />
  };

  render () {
    // mobile we only show a single view, not a dual
    if (this.state.isMobile && this.props.routeIntention === 'list') return this.renderList()
    if (this.state.isMobile) { // default to new
      return <div>
        {this.renderForm({ redirectToPricelistAfterSubmit: true })}
        {this.renderCartButton()}
      </div>
    }

    return <div className={classes['dual-view']}>
      {this.renderForm({ partial: true })}
      {this.renderList({ partial: true })}
    </div>
  }
}

Orders.propTypes = {
  // states
  order: PropTypes.object,
  orders: PropTypes.array.isRequired,
  staging: PropTypes.array,
  pricelist: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  uoms: PropTypes.array.isRequired,
  routes: PropTypes.array,
  customers: PropTypes.array,

  // container / params
  date: PropTypes.any,

  // react-router
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,

  // so we can use either /new or /:id/edit with this Component
  editing: PropTypes.bool,

  // from react-redux
  dispatch: PropTypes.func.isRequired,

  // from router getComponent props
  routeIntention: PropTypes.string
}

Orders.defaultProps = {
  order: {},
  orders: [],
  staging: [],
  pricelist: [],
  options: [],
  uoms: [],
  routes: [],
  customers: [],

  editing: false,

  routeIntention: 'form' // 'list|form', form is default
}

export default Orders



// WEBPACK FOOTER //
// ./src/components/Orders/Orders.js